import { Component } from "react"
import PropTypes from "prop-types"

import "./hover_trigger.scss"

export default class HoverTrigger extends Component {
  state = {
    hoverable: true,
  }

  onHover = () => {
    this.state.hoverable && this.setState({ hoverable: false })
  }

  onMouseLeave = e => {
    this.setState({ hoverable: true })
  }

  render() {
    return (
      <div styleName={this.props.triggerLocation} onMouseOver={this.onHover}>
        {!this.state.hoverable && (
          <div onMouseLeave={this.onMouseLeave} styleName="panel-container">
            {this.props.children}
          </div>
        )}
      </div>
    )
  }
}

HoverTrigger.propTypes = {
  triggerLocation: PropTypes.string,
}
